/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ReportsFindCoordinatesStatusItem } from './reportsFindCoordinatesStatusItem';
import type { ReportsFindCoordinatesAnimalTypeItem } from './reportsFindCoordinatesAnimalTypeItem';
import type { ReportsFindCoordinatesWildTypeItem } from './reportsFindCoordinatesWildTypeItem';
import type { ReportsFindCoordinatesSurveillanceTypeItem } from './reportsFindCoordinatesSurveillanceTypeItem';
import type { ReportsFindCoordinatesCategoryOfTestItem } from './reportsFindCoordinatesCategoryOfTestItem';

export type ReportsFindCoordinatesParams = {
  /**
   * Filter by report code (support incomplete search)
   */
  code?: string;
  /**
   * Filter by publication status
   */
  status?: ReportsFindCoordinatesStatusItem[];
  /**
   * Filter by animal type
   */
  animalType?: ReportsFindCoordinatesAnimalTypeItem[];
  /**
   * Filter by species
   */
  specie?: string;
  /**
   * Filter by wild type
   */
  wildType?: ReportsFindCoordinatesWildTypeItem[];
  /**
   * Filter by surveillance type
   */
  surveillanceType?: ReportsFindCoordinatesSurveillanceTypeItem[];
  /**
   * Filter by detection date (from) - ISO 8601 format
   */
  detectionDateFrom?: string;
  /**
   * Filter by detection date (to) - ISO 8601 format
   */
  detectionDateTo?: string;
  /**
   * Filter by order
   */
  order?: string;
  /**
   * Filter by user reports only
   */
  myReports?: boolean;
  /**
   * Filter by country code
   */
  countryCode?: string[];
  /**
   * Filter by region id
   */
  regionId?: string[];
  /**
   * Filter by known cause
   */
  knownCause?: boolean;
  /**
   * Filter by etiology type code
   */
  etiologyTypeCode?: string[];
  /**
   * Filter by etiological agent code
   */
  etiologicalAgentCode?: string[];
  /**
   * Filter reports that have at least one diagnostic procedure
   */
  hasDiagnosticProcedure?: boolean;
  /**
   * Filter reports that have diagnostic procedures with specific category of test
   */
  categoryOfTest?: ReportsFindCoordinatesCategoryOfTestItem[];
  /**
   * Filter reports that have diagnostic procedures with specific sample type code
   */
  sampleTypeCode?: string[];
};
